import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    bindings: {
        form: '=',
        successMessage: '@',
        additionalClasses: '@'
    },
    template: `
        <div class="form {{ vm.additionalClasses }}">
            <alert-error ng-if="vm.form.invalid">{{ 'general.There were errors processing the form' | translate }}</alert-error>
            <alert-success ng-if="vm.form.saved">
                <span ng-if="!vm.successMessage">{{ 'general.Changes saved' | translate }}</span>
                <span ng-if="vm.successMessage">{{ vm.successMessage }}</span>
            </alert-success>
            <ng-transclude></ng-transclude>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/form/wrapper/index.js